export function SurveyCredit() {
  const year = new Date().getFullYear()
  return (
    <div id="survey-credit" className="pull-right">
      BalancedComp {year}
    </div>
  )
}
